import { api, canWrite, send } from "../api";
import { blockWhat } from "../parts";
import type { Block } from "../types";
import { ago, confirmButton, date, dateTime, flash, form, h, input, select, show, statusChip, table, td, th, userLink } from "../ui";

export async function blocksPage() {
  const d = await api<{ blocks: Block[] }>("/v1/admin/blocks");
  if (!d) return;
  const write = canWrite();
  const kind = select({ id: "b-kind", "aria-label": "Kind" }, [["ip", "IP or range"], ["account", "Account id"], ["device", "Device id"]]);
  const value = input({ id: "b-value", placeholder: "203.0.113.0/24", autocomplete: "off" });
  const reason = input({ id: "b-reason", placeholder: "Why (kept with the block)", maxlength: "200" });
  const daysIn = input({ id: "b-days", type: "number", min: "1", max: "3650", placeholder: "Days" });
  kind.addEventListener("change", () => (value.placeholder = kind.value === "ip" ? "203.0.113.0/24" : kind.value === "account" ? "acct_…" : "dev_…"));
  const blockForm = form(
    "blockform",
    async () => {
      const r = await send<{ effect: string }>("POST", "/v1/admin/blocks", { kind: kind.value, value: value.value.trim(), reason: reason.value.trim(), ...(daysIn.value ? { days: Number(daysIn.value) } : {}) });
      await blocksPage();
      flash(r.effect);
    },
    h("label", null, "Block", kind),
    h("label", null, "What", value),
    h("label", null, "Reason", reason),
    h("label", null, "For (empty: until lifted)", daysIn),
    h("button", { class: "btn primary", type: "submit" }, "Block"),
  );
  const active = d.blocks.filter((b) => b.active);
  const past = d.blocks.filter((b) => !b.active);
  show(
    "Blocks",
    "IP addresses, accounts and devices Luwu refuses, and sessions ended on computers. Team admins' blocks stay with their team.",
    write ? blockForm : null,
    h("p", { class: "muted" }, "An IP is refused by the API now and by relays within 30 seconds. An account loses its sign-ins and its devices are revoked. A device is revoked. Lifting lets it back in; revoked devices pair or register again."),
    h("h2", null, `Active (${active.length})`),
    table(
      [th("Kind"), th("What"), th("Reason"), th("Since", "num"), th("Until", "num"), th("", "num")],
      active.map((b) =>
        h(
          "tr",
          null,
          td(b.kind),
          b.kind === "account" ? h("td", null, userLink(b.value, blockWhat(b))) : td(blockWhat(b)),
          td(b.reason || "—"),
          td(ago(b.created_at), "num"),
          td(b.expires_at ? date(b.expires_at) : "lifted by hand", "num"),
          write
            ? h("td", { class: "num" }, confirmButton("Lift", "Lift it", async () => {
                await send("DELETE", `/v1/admin/blocks/${b.id}`);
                await blocksPage();
                flash("Lifted.");
              }, "btn small plain"))
            : td("", "num"),
        ),
      ),
      "Nothing blocked.",
    ),
    h("h2", null, "History"),
    table(
      [th("Kind"), th("What"), th("Reason"), th("When", "num"), th("State")],
      past.map((b) => h("tr", null, td(b.kind), td(blockWhat(b)), td(b.reason || "—"), td(dateTime(b.created_at), "num"), h("td", null, statusChip(b.kind === "session" ? "ended" : b.lifted_at ? "lifted" : "expired")))),
      "Nothing yet.",
    ),
  );
}
